import { getCheck24Namespace } from 'utility/Provide/Namespace/getCheck24Namespace';

import { GlobalNamespace } from 'types/legacy/namespace';

export function useBoUser() {
    const namespace: GlobalNamespace = getCheck24Namespace();

    return !!namespace?.components?.backendInformationFunc?.isBoUser();
}
